export default {
  props: ['info'],
  data: () => {
    return {
    };
  },
  computed: {
    address () {
      const region = this.info.region || {};
      let str = region.province;
      if (region.city && region.city !== region.province) {
        str += '-' + region.city;
      }
      if (region.district) {
        str += '-' + region.district;
      }
      if (region.town) {
        str += '-' + region.town;
      }
      if (region.village) {
        str += '-' + region.village;
      }
      if (this.info.address && region.province) {
        str += '-' + this.info.address;
      }
      return str;
    }
  },

  created () {
  },

  methods: {
  }
};
